import ServiceCard from '../components/ServiceCard';

function Services() {
  return (
    <section className="py-16 pt-24 bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-navy text-center mb-12 animate-fade-in">Our Services</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <ServiceCard
            title="Bridge Painting"
            description="We provide specialized coatings for bridges, ensuring corrosion resistance and compliance with safety standards. Our solutions are designed for durability in harsh environments."
            image="/img/bridge-project.jpeg"
          />
          <ServiceCard
            title="Water Tower Painting"
            description="Our water tower painting services include surface preparation, high-performance coatings, and logo application, meeting all regulatory requirements."
            image="/img/water-t4ower-project.jpeg"
          />
          <ServiceCard
            title="Commercial Painting"
            description="We offer professional painting for commercial buildings, delivering aesthetic appeal and long-lasting protection with minimal disruption."
            image="/img/commercial-project.jpeg"
          />
        </div>
      </div>
    </section>
  );
}

export default Services;